export default __webpack_public_path__ + "static/media/diamond_badge.5c89702f.png";